import { components as c } from "@/components";
import { roleOptions } from "../../../definitions/roles";

const SelectRole = () => {
	return <c.fc.Select name="role" label="Role" options={roleOptions} />;
};

export default SelectRole;
